import { render } from "./Carousel.vue?vue&type=template&id=47cfb1bf&scoped=true"
import script from "./Carousel.vue?vue&type=script&lang=ts"
export * from "./Carousel.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-47cfb1bf"

export default script
import QForm from 'quasar/src/components/form/QForm.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QSelect,QInput});
